import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

export function DatePicker({
  value,
  onChange,
  placeholder = "Pick a date",
}: {
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  placeholder?: string;
}) {
  const formatted = value
    ? value.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      })
    : undefined;

  return (
    <Popover>
      <PopoverTrigger
        className={cn(
          "flex h-8 w-36 items-center gap-2 rounded-md border bg-background px-2.5 text-sm transition-colors hover:bg-accent",
          !value && "text-muted-foreground",
        )}
      >
        <CalendarIcon className="size-3.5 text-muted-foreground" />
        <span className="flex-1 truncate text-left">{formatted ?? placeholder}</span>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={8} className="w-auto p-0 animate-none">
        <Calendar mode="single" selected={value} onSelect={onChange} autoFocus />
      </PopoverContent>
    </Popover>
  );
}
